<template>
  <div id="func-16">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
    />
    <SolicitacaoHistorico
      :chave-externa="'extrato'"
      :funcionalidade="funcionalidade"
      :lista-externa="listaComData"
      :rota-detalhe="rotaDetalhe"
    >
      <template v-slot:default="{card}">
        <div
          @click="onClickRow(card)"
        >
          <ListaExtratoCard
            :card="card"
            :showWidgetActions="showWidgetActions"
            :preloadWidget="() => carregaPayloadWidget(card)"
          />
        </div>
      </template>
    </SolicitacaoHistorico>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoHistorico from '@/components/TemplateSolicitacao/SolicitacaoHistorico'
import ListaExtratoCard from '@/components/TemplateSolicitacao/componentes/ListaExtratoCard'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import { preloadWidget } from '@/views/10/PreLoadWidget10'

export default {
  name: 'Func16Historico',
  components: {
    ListaExtratoCard,
    SolicitacaoHistorico,
    FuncionalidadeHeader
  },
  data () {
    return {
      contratosList: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade', 'embedJson']),
    ...mapGetters('Login', ['user']),
    ...mapGetters('SetupApp', ['canalAtendimentoOrigem']),
    showWidgetActions () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return false
      }
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    listaComData () {
      let data = []
      let lista = this.contratosList
      if (lista.length > 0) {
        lista.map((obj) => {
          const tempLista = obj.extrato.map((el) => {
            let data = el.dataSolicitacao
            let timestamp = new Date(data).getTime()
            return {
              ...el,
              data_registro: timestamp,
              cardExterno: true
            }
          })
          data.push({
            numeroContrato: obj.numeroContrato,
            extrato: tempLista
          })
        })
      }
      return data
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    }
  },
  methods: {
    async init () {
      await this.listaExtratos()
    },
    async listaExtratos () {
      const range = this.funcionalidade.parametros.rangeDataListaReembolso
      const hoje = new Date()
      const dataInicial = new Date(hoje)
      dataInicial.setMonth(dataInicial.getMonth() - range)
      const dataFinal = new Date(hoje)
      dataFinal.setMonth(dataFinal.getMonth() + range)
      const formatarData = data =>
        data.toISOString().split('T')[0]

      let result = await this.apiFuncionalidade.lista({
        payload: {
          dataInicial: formatarData(dataInicial),
          dataFinal: formatarData(dataFinal)
        },
        handlerErrorIgnore: true
      })
      this.contratosList = result.data.contratos
    },
    onClickRow (row) {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return this.$router.push({
            path: `/${this.funcionalidade.idFuncionalidade}/detalhe`,
            query: {
              idOcorrencia: row['idReembolso'],
              idGuia: row['numeroGuiaReembolso']
            }
          })
      }
    },
    carregaPayloadWidget (row) {
      return preloadWidget(
        row,
        this.funcionalidade,
        this.embedJson.atendimento.tokenAtendente,
        this.aplicacao
      )
    }
  },
  mounted () {
    this.init()
  }
}
</script>
